import type { BaseModalProps } from '@byecode/ui/components/Modal'
import { SpaceVersion } from '@lighthouse/core'
import { spaceGradeUploadLimitMap } from '@lighthouse/shared'
import type { ModalProps } from '@mantine/core'

import type { SpaceVersionStaticInfo } from './types'

export const versionModalStyles: BaseModalProps['styles'] = {
    header: {
        borderColor: 'transparent'
    },
    modal: {
        margin: '0 60px',
        maxWidth: 1692,
        height: '90%',
        width: 'calc(100% - 120px)',
        overflow: 'hidden'
    },
    body: {
        padding: 0
    }
}

export const modalStyles: ModalProps['styles'] = {
    close: {
        top: 30,
        right: 26,
        zIndex: 10,
        cursor: 'pointer',
        '>*': {
            width: 32,
            height: 32
        }
    },
    header: {
        height: 0,
        marginBottom: 0
    }
}

export const ALL_SPACE_VERSION: SpaceVersionStaticInfo[] = [
    {
        describe: '适用于个人构建项目 & 探索 ByeCode',
        accessUserLimit: 500,
        externalUserLimit: 10,
        accessFlow: 1024 * 3,
        recordsLimit: 500,
        storageLimit: 1024,
        videoQuality: 'HD',
        singleFileSizeLimit: spaceGradeUploadLimitMap.FREE,
        version: SpaceVersion.FREE,
        price: 0,
        publishedWxProgram: false,
        coreFunction: ['组件库', '自定义用户角色', '工作流']
    },
    {
        describe: '适用于名片 & 微网站',
        price: 360,
        accessUserLimit: 10000,
        externalUserLimit: 20,
        accessFlow: 1024 * 10 * 3,
        recordsLimit: 2000,
        storageLimit: 1024 * 5,
        videoQuality: 'HD',
        singleFileSizeLimit: spaceGradeUploadLimitMap.BASIC,
        version: SpaceVersion.BASIC,
        coreVersion: SpaceVersion.BASIC,
        publishedWxProgram: false,
        coreFunction: ['SEO', '应用访问统计分析', '绑定自有域名']
    },
    {
        describe: '适用于网站 & 轻量业务应用',
        price: 1500,
        accessUserLimit: 200000,
        externalUserLimit: 100,
        accessFlow: 1024 * 100,
        recordsLimit: 10000,
        storageLimit: 1024 * 100,
        videoQuality: 'HD',
        singleFileSizeLimit: spaceGradeUploadLimitMap.STANDARD,
        version: SpaceVersion.STANDARD,
        coreVersion: SpaceVersion.STANDARD,
        publishedWxProgram: false,
        coreFunction: ['多语言版本', '页面统计', '单附件大小 100MB']
    },
    {
        describe: '适用于网站门户、小程序 & 业务管理应用',
        price: 6800,
        accessUserLimit: -1,
        externalUserLimit: 2000,
        accessFlow: 1024 * 1024,
        recordsLimit: 500000,
        storageLimit: 1024 * 500,
        videoQuality: 'HD',
        singleFileSizeLimit: spaceGradeUploadLimitMap.ADVANCED,
        version: SpaceVersion.ADVANCED,
        coreVersion: SpaceVersion.ADVANCED,
        publishedWxProgram: true,
        coreFunction: ['微信小程序', '支付能力', '附件存储增购']
    },
    {
        describe: '适用于业务复杂的小程序、私域中心 & 管理系统',
        price: 12800,
        accessUserLimit: -1,
        externalUserLimit: -1,
        accessFlow: 2048 * 1024,
        recordsLimit: 1000000,
        storageLimit: 1024 * 1024,
        videoQuality: 'FHD',
        singleFileSizeLimit: spaceGradeUploadLimitMap.PROFESSIONAL,
        version: SpaceVersion.PROFESSIONAL,
        coreVersion: SpaceVersion.PROFESSIONAL,
        publishedWxProgram: true,
        coreFunction: ['移动端 & Web PWA app', '不限登陆用户数量', '关闭 ByeCode 小程序 logo']
    },
    {
        describe: '适用于企业级业务管理系统 & 扩展团队及业务',
        price: 25800,
        accessUserLimit: -1,
        externalUserLimit: -1,
        accessFlow: 5120 * 1024,
        recordsLimit: 2000000,
        storageLimit: 2048 * 1024,
        videoQuality: 'FHD',
        singleFileSizeLimit: spaceGradeUploadLimitMap.ENTERPRISE,
        version: SpaceVersion.ENTERPRISE,
        coreVersion: SpaceVersion.ENTERPRISE,
        publishedWxProgram: true,
        coreFunction: ['工作流运行次数增购', '不限API调用次数', '两百万单表数据量']
    }
]
